/**
 * @flow
 * @relayHash dbb2c63affcfd63eef005614b23eae29
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type SharedEditMeasurementUnitPreferenceMutationVariables = {|
  input: {
    userServiceId: string;
    firstName?: ?string;
    lastName?: ?string;
    email?: ?string;
    currency?: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
    measurementUnit?: ?"CM" | "IN";
    zipCode?: ?string;
    clientMutationId?: ?string;
  };
|};
export type SharedEditMeasurementUnitPreferenceMutationResponse = {|
  +editPersonalProfile: ?{|
    +user: ?{|
      +profile: ?{|
        +measurementUnit: ?"CM" | "IN";
      |};
    |};
  |};
|};
*/


const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "EditPersonalProfileInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SharedEditMeasurementUnitPreferenceMutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "EditPersonalProfileInput!"
          }
        ],
        "concreteType": "EditPersonalProfilePayload",
        "name": "editPersonalProfile",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "User",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Profile",
                "name": "profile",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "measurementUnit",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": "app-buyer-finding/197.0.0-2018-12-19T18:19:19.050Z/SharedEditMeasurementUnitPreferenceMutation",
  "kind": "Batch",
  "metadata": {},
  "name": "SharedEditMeasurementUnitPreferenceMutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "EditPersonalProfileInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "SharedEditMeasurementUnitPreferenceMutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "EditPersonalProfileInput!"
          }
        ],
        "concreteType": "EditPersonalProfilePayload",
        "name": "editPersonalProfile",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "User",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Profile",
                "name": "profile",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "measurementUnit",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": null
};

module.exports = batch;
